import ArchivedSeparator from './ArchivedSeparator';
export default ArchivedSeparator;
